import React from "react";
const IconCashier = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13 5.5V3H4V8M13 5.5H16V11.5H13M13 5.5V8M13 11.5V14H11.5M13 11.5V11M5.5 14H4V11M5.5 14V17L7 16L8.5 17L10 16L11.5 17V14M5.5 14H7M11.5 14H10M4 11H13M4 11V8M13 11V8M4 8H7M13 8H10M7 8V14M7 8H10M7 14H10M10 8V14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconCashier;
